import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import TeamMember from '../TeamMember/TeamMember';

const WidgetSection = ({ userId, members, userIdToAvatar, captainId }) => {
  if (!members.length) return null;
  return (
    <>
      {map(members, (member, index) => {
        return (
          <TeamMember
            key={index}
            member={member}
            avatar={userIdToAvatar[member.userId]}
            userId={userId}
            captainId={captainId}
          />
        );
      })}
    </>
  );
};

WidgetSection.propTypes = {
  members: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        userId: PropTypes.number.isRequired,
        invitedByName: PropTypes.string,
      }),
      PropTypes.string,
    ])
  ).isRequired,
  userIdToAvatar: PropTypes.objectOf(PropTypes.string),
  userId: PropTypes.number,
  captainId: PropTypes.number,
};

WidgetSection.defaultProps = {
  userId: null,
  captainId: null,
  userIdToAvatar: null,
};

export default WidgetSection;
